/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import kendo from '@bingads-webui/kendo/kendo.data.odata';
import odata_4 from '@bingads-webui-static-legacy/communication/adapter/odata-4';
import * as filterMetadata from '@bingads-webui/filter-commons';
import pageContext from '@bingads-webui-static-legacy/page-context';
import dateUtils from '@bingads-webui-static-legacy/utils/date';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
function convertDateToStandardFormat(dateString) {
  return dateUtils.parse(dateString);
}
function convertToPoPField(field, popOption) {
  if (popOption && popOption != 0) {
    if (field.indexOf('/') != -1) {
      var strings = field.split('/');
      if (strings.length >= 2) {
        var category = strings[0];
        var column = strings[1];
        if (popOption == 1) {
          category = 'PoP' + category;
        } else if (popOption == 2) {
          category = 'PoP' + category + 'Change';
        } else if (popOption == 3) {
          category = 'PoP' + category + 'ChangePercentage';
        } else {
          return field;
        }
        var result = category + '/' + column;
        return result;
      }
    }
  } else {
    return field;
  }
}
function toKendo(filterExpressions, entityType) {
  var filters = [];
  _.each(filterExpressions, function (item) {
    if (!item) {
      return;
    }
    var selectedColumn = item.SelectedColumn;
    var popOption = item.PeriodComparisonOption;
    var popPrefix = 'PoP';
    if ((/^PoP/).test(selectedColumn)) {
      var change = 'Change';
      var changePercent = 'ChangePercent';
      if (selectedColumn.match(change + '$')) {
        popOption = 2;
        selectedColumn = selectedColumn.slice(popPrefix.length, -change.length);
      } else if (selectedColumn.match(changePercent + '$')) {
        popOption = 3;
        selectedColumn = selectedColumn.slice(popPrefix.length, -changePercent.length);
      } else {
        popOption = 1;
        selectedColumn = selectedColumn.slice(popPrefix.length);
      }
    }
    var type = filterMetadata.columnTypeMapper(selectedColumn);
    var filterExpression = {
      field: filterMetadata.columnNameMapper(selectedColumn, entityType),
      operator: filterMetadata.operatorMapper(item.SelectedOperator, type)
    };
    if (popOption && popOption != 0) {
      filterExpression.field = convertToPoPField(filterExpression.field, popOption);
    }
    if (_.isArray(item.Values)) {
      if (item.Values.length > 1) {
        var opr = filterExpression.operator, subExpressions = [];
        _.each(item.Values, function (valueItem, index) {
          if (type === 'date') {
            valueItem = convertDateToStandardFormat(valueItem);
          }
          if (_.isArray(filterExpression.operator)) {
            opr = filterExpression.operator[index];
          }
          subExpressions.push({
            field: filterExpression.field,
            operator: opr,
            value: filterMetadata.valueFormatter(valueItem, type, filterExpression.field, entityType, decimal)
          });
        });
        filters.push({
          logic: _.isArray(filterExpression.operator) ? 'and' : 'or',
          filters: subExpressions
        });
      } else {
        if (type === 'date') {
          item.Values[0] = convertDateToStandardFormat(item.Values[0]);
        }
        filterExpression.value = filterMetadata.valueFormatter(item.Values[0], type, filterExpression.field, entityType, decimal);
        filters.push(filterExpression);
      }
    }
  });
  return {
    filters: filters
  };
}
function convertForLambdaExpression(filterExpressions, entityType) {
  var url = '';
  var indexToDelete = [];
  _.each(filterExpressions, function (item, index) {
    if (!item) {
      return;
    }
    var lambdaMappedResult = filterMetadata.lambdaMapper(item.SelectedOperator, item.SelectedColumn, entityType, item.Values);
    if (!_.isEmpty(lambdaMappedResult) && !_.isEmpty(item.Values)) {
      var partialUrl = lambdaExpressionMapping(item, lambdaMappedResult, entityType);
      if (url.length > 0) {
        url += ' and (';
        url += partialUrl;
        url += ')';
      } else {
        url += partialUrl;
      }
      indexToDelete.push(index);
    }
  });
  _.each(indexToDelete, function (index) {
    delete filterExpressions[index];
  });
  filterExpressions = _.without(filterExpressions, undefined);
  return url;
}
function lambdaExpressionMapping(item, lambdaMappedResult, entityType) {
  var partialUrl = '';
  var columnName = filterMetadata.columnNameMapper(item.SelectedColumn, entityType);
  var type = filterMetadata.columnTypeMapper(item.SelectedColumn);
  var fieldId = lambdaMappedResult.fieldId;
  if (lambdaMappedResult.mapToShorterVersion) {
    partialUrl += columnName;
    partialUrl += '/' + lambdaMappedResult.secondLogic + '(d:';
  }
  _.each(item.Values, function (value, index) {
    if (index > 0) {
      partialUrl += ' ' + lambdaMappedResult.logic + ' ';
    }
    var mappedOperatorAndValue = '';
    if (!_.isEmpty(lambdaMappedResult.operator)) {
      mappedOperatorAndValue = ' ' + lambdaMappedResult.operator + ' ' + (_.isUndefined(lambdaMappedResult.value) ? filterMetadata.valueFormatter(value, type, columnName, entityType, decimal) : lambdaMappedResult.value);
    }
    if (lambdaMappedResult.mapToShorterVersion) {
      partialUrl += fieldId + mappedOperatorAndValue;
    } else {
      partialUrl += columnName;
      partialUrl += '/' + lambdaMappedResult.secondLogic + '(' + fieldId + mappedOperatorAndValue + ')';
    }
  });
  if (lambdaMappedResult.mapToShorterVersion) {
    partialUrl += ')';
  }
  return partialUrl;
}
function convert(filterExpressions, entityType) {
  var filterExpressionsCopy = _.isEmpty(filterExpressions) ? {} : $.extend(true, {}, filterExpressions);
  var lamdaExpressionUrlPart = convertForLambdaExpression(filterExpressionsCopy, entityType);
  var odata_params = kendo.data.transports.odata.parameterMap({
    filter: toKendo(filterExpressionsCopy, entityType)
  }, 'read');
  var result = odata_4.from(odata_params);
  if (!_.isEmpty(lamdaExpressionUrlPart) && lamdaExpressionUrlPart.length > 0) {
    result.$filter = result.$filter || '';
    result.$filter += result.$filter.length > 0 ? ' and ' : '';
    result.$filter += lamdaExpressionUrlPart;
  }
  return result;
}
function convertToURLParam(filterExpressions, entityType) {
  var expression = convert(filterExpressions, entityType);
  if (expression && expression.$filter) {
    return '$filter=' + encodeURIComponent(expression.$filter);
  }
  return '';
}
export default {
  toKendo: toKendo,
  convertForLambdaExpression: convertForLambdaExpression,
  convert: convert,
  convertToURLParam: convertToURLParam
};

